import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// context
import { Shadow, Light } from "core/Modal2";
import {
    ContentStyled,
    CloseButtonStyled
} from "core/Modal2/components/styles.js";

// components
import Content from "./Content";

// styles
import { convertPxToRem } from "frontend/components/helpers";
const ModalStyled = styled.div`
    ${ContentStyled} {
        padding: 0px;
        text-align: left;
        overflow: hidden;
    }
    ${CloseButtonStyled} {
        position: relative;
        top: ${convertPxToRem(8)};
    }
`;

// component
export const Modal = ({ userMessage }) => {
    const { modalImageUrl } = userMessage;

    let dimensions = {
        w: convertPxToRem(720),
        h: "auto"
    };

    if (!modalImageUrl) {
        dimensions.w = convertPxToRem(430);
        dimensions.h = "auto";
    }

    return (
        <ModalStyled>
            <Shadow>
                <Light
                    headerHeight="63px"
                    isFullScreen={false}
                    dimensions={dimensions}
                >
                    <Content userMessage={userMessage} />
                </Light>
            </Shadow>
        </ModalStyled>
    );
};

export default Modal;

// prop-types
Modal.propTypes = {
    userMessage: PropTypes.object.isRequired
};
